module.exports = __webpack_public_path__ + "img/logo-mobile.701b5ad8.svg";